import Papa from 'papaparse'

/**
 * Método que pega uma string separado por ; e transforma a string
 * em um csv para o usuário
 */
const stringToExportCSV = (fileName, csvString) => {
	var csvFile = new Blob(['\ufeff', csvString], { type: 'text/csv' })
	var downloadLink = document.createElement('a')
	downloadLink.download = `${fileName}.csv`
	downloadLink.href = window.URL.createObjectURL(csvFile)
	downloadLink.click()
}

/**
 * Monta uma string CSV (separador ;) com ESCAPAMENTO correto: campo contendo
 * ; aspas ou quebra de linha sai entre aspas duplas (Papa.unparse). O join(';')
 * manual usado historicamente nas grids corrompia as colunas nesses casos.
 *
 * @param {string[]} cabecalho - títulos das colunas
 * @param {Array<Array>} linhas - matriz de valores (null/undefined viram '')
 */
const montarCsv = (cabecalho, linhas) => {
	return Papa.unparse({ fields: cabecalho, data: linhas }, { delimiter: ';', newline: '\r\n' })
}

/**
 * Atalho: monta o CSV escapado e dispara o download (com BOM p/ Excel).
 */
const exportarCsv = (fileName, cabecalho, linhas) => {
	stringToExportCSV(fileName, montarCsv(cabecalho, linhas))
}

export { stringToExportCSV, montarCsv, exportarCsv }
